import http from './http'

/**
 * Register a new user account.
 * @param {{ email: string, displayName: string, password: string }} payload
 * @returns {Promise<{ message: string }>}
 */
export function register (payload) {
  return http.post('/auth/register', payload).then(function (res) {
    return res.data
  })
}

/**
 * Log in and receive JWT tokens.
 * @param {{ email: string, password: string }} credentials
 * @returns {Promise<{ accessToken: string, refreshToken: string, tokenType: string, expiresIn: number, role: string, displayName: string, email: string }>}
 */
export function login (credentials) {
  return http.post('/auth/login', credentials, { _skipAuth: true }).then(function (res) {
    return res.data
  })
}

/**
 * Rotate access + refresh tokens.
 * Relies on the HttpOnly refresh_token cookie (withCredentials: true), but the
 * response body also returns the rotated raw refreshToken.
 * @param {string} [refreshToken] Optional – pass the raw token if not using cookies.
 * @returns {Promise<{ accessToken: string, refreshToken: string, expiresIn: number }>}
 */
export function refreshToken (refreshToken) {
  var body = refreshToken ? { refreshToken: refreshToken } : {}
  return http.post('/auth/refresh', body, { _skipAuth: true }).then(function (res) {
    return res.data
  })
}

/**
 * Revoke the refresh token and clear the cookie.
 * @param {string} [refreshToken]
 * @returns {Promise<void>}
 */
export function logout (refreshToken) {
  var body = refreshToken ? { refreshToken: refreshToken } : {}
  return http.post('/auth/logout', body).then(function () {})
}

/**
 * Verify an email address using the one-time token from the verification email.
 * @param {string} token
 * @returns {Promise<{ message: string }>}
 */
export function verifyEmail (token) {
  return http.get('/auth/verify-email', { params: { token: token } }).then(function (res) {
    return res.data
  })
}

/**
 * Trigger a password-reset email for the given address.
 * Always returns 202 regardless of whether the address is registered (prevents enumeration).
 * @param {string} email
 * @returns {Promise<{ message: string }>}
 */
export function initiatePasswordReset (email) {
  return http.post('/auth/password-reset/initiate', { email: email }, { _skipAuth: true }).then(function (res) {
    return res.data
  })
}

/**
 * Set a new password using the one-time token from the reset email.
 * Also revokes all existing refresh tokens for the user.
 * @param {{ token: string, newPassword: string }} payload
 * @returns {Promise<void>}
 */
export function confirmPasswordReset (payload) {
  return http.post('/auth/password-reset/confirm', payload, { _skipAuth: true }).then(function () {})
}
